import NextImage from '@/components/NextImage';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useEffect, useState } from 'react';
import { EFPowerOceanYearsIconEN } from './EFPowerOceanYearsIconEN';

export default function ReliableQuality() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.ReliableQuality');

    const [isPc, setIsPc] = useState(true);
    const handleResize = () => {
        window.innerWidth <= 1024 ? setIsPc(false) : setIsPc(true);
    };
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={`${styles.reliableQuality}`}>
            <div className="head-box">
                <div className="sub-title">{t('label')}</div>
                <h2 className="title">{t('title')}</h2>
            </div>
            {isPc ? (
                <div className="solution-item">
                    <div className="row-item">
                        <div className="container">
                            <div className="text-box">
                                <h3 className="title">{t('item_title1')}</h3>
                                <div className="desc">{t('item_desc1')}</div>
                            </div>
                        </div>
                        <div className="bg-img">
                            <EFPowerOceanYearsIconEN />
                        </div>
                    </div>
                    <div className="row-item2">
                        <div className="item">
                            <div className="bg-img">
                                <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717658215913/pc-tuya.jpg" alt={t('item_title2')} />
                            </div>
                            <div className="text-box">
                                <h3 className="title"> {t('item_title2')}</h3>
                                <div className="desc"> {t('item_desc2')}</div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="bg-img">
                                <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717658207880/pc1-tuya.jpg" alt={t('item_title3')} />
                            </div>
                            <div className="text-box">
                                <h3 className="title"> {t('item_title3')}</h3>
                                <div className="desc"> {t('item_desc3')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="solution-item-h5">
                    <div className="scroll-box">
                        <div className="item">
                            <div className="bg-img-h5">
                                <EFPowerOceanYearsIconEN />
                            </div>
                            <div className="text-box">
                                <h3 className="title">{t('item_title1')}</h3>
                                <div className="desc">{t('item_desc1')}</div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="bg-img-h5">
                                <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717658198190/mo-tuya.jpg" alt={t('item_title2')} />
                            </div>
                            <div className="text-box">
                                <h3 className="title"> {t('item_title2')}</h3>
                                <div className="desc"> {t('item_desc2')}</div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="bg-img-h5">
                                <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717658201396/mo1-tuya.jpg" alt={t('item_title3')} />
                            </div>
                            <div className="text-box">
                                <h3 className="title"> {t('item_title3')}</h3>
                                <div className="desc"> {t('item_desc3')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
